import { CloseButton } from '@repo/common';

const ResumeBottomSheet = ({ title, isOpen, onClose, children, footer }) => {
  if (!isOpen) return null;

  return (
    <div
      className='fixed inset-0 z-[1000000000] flex items-end bg-surface-black40'
      onClick={onClose}
    >
      {/* 목록이 길어져도 시트가 화면을 넘지 않도록 높이를 제한하고 본문만 스크롤한다 */}
      <div
        className='relative flex max-h-[88vh] w-full flex-col rounded-t-[40px] bg-grayscale-gray00 px-6 pt-4 pb-[calc(env(safe-area-inset-bottom)+8px)] animate-slideUp'
        onClick={(e) => e.stopPropagation()}
      >
        <div className='shrink-0 pb-8'>
          <div className='mx-auto h-[6px] w-[46px] rounded-full bg-grayscale-gray02' />
        </div>

        <div className='flex min-h-0 flex-1 flex-col gap-4'>
          <div className='flex shrink-0 items-center justify-between'>
            <div className='typo-title1 text-text-primary'>{title}</div>
          </div>
          <div className='-mx-1 min-h-0 flex-1 overflow-y-auto scrollbar-hide px-1'>
            {children}
          </div>
        </div>

        {footer && (
          <div className='shrink-0 bg-grayscale-gray00 pt-2'>{footer}</div>
        )}
      </div>
    </div>
  );
};

export default ResumeBottomSheet;
